// import queryString from "query-string";
import React, { useContext, useState } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  CustomView,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import api from "../../../../api";
import values from "../../../../values";
import Context from "../../../../context";
import {
  ICityItem,
  ICompanyItem,
  IItem,
  IOnSearchUser,
  IProvinceItem,
} from "../../../../types/common.interface";
import utils from "../../../../utils";
import { useTranslation } from "react-i18next";
import { gender } from "../../../../values/dropdownItems";

const FilterAgent = () => {
  // ============================== Value Validation ================================
  const { t } = useTranslation();

  const { requestService, setRequestService } = useContext(
    Context.ServiceScreen
  );

  const [selectedParent, setSelectedParen] = useState<any>();
  const [searchedValueParent, setSearchedValueParent] =
    React.useState<IOnSearchUser>();
  const parentPropertyPath =
    values.dropdownBaseSearch.COMPANY_BASE_SEARCH_SUPERAGENT_ROLE.map(
      (item) => {
        switch (item.value) {
          case "PHONE_NUMBER":
            return { ...item, value: "phoneNumber", base: "PHONE_NUMBER" };
          case "FIRST_NAME":
            return { ...item, value: "firstName", base: "FIRST_NAME" };
          case "LAST_NAME":
            return { ...item, value: "lastName", base: "LAST_NAME" };
        }
      }
    );

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  let baseSearch =
    userType === "ADMIN"
      ? values.dropdownBaseSearch.PARENT_BASE_SEARCH
      : values.dropdownBaseSearch.PARENT_BASE_SEARCH_SUPERAGENT;

  baseSearch = baseSearch.map((item) => {
    return { ...item, title: t(item?.title) };
  });

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, requestService?.filters?.province],
    () =>
      api.get.common.getAllCity({
        provinceCode: requestService?.filters?.province?.Code,
      })
  );
  const getAllSuperAgent = useQuery(
    [values.useQueryKeys.getAllSuperAgent],
    () => api.post.administrator.getAllSuperAgent({}),
    { enabled: userType === "ADMIN" }
  );
  const getAllCompany = useQuery(
    [values.useQueryKeys.getAllCompany],
    () => api.post.administrator.getAllCompany({}),
    { enabled: userType === "ADMIN" }
  );
  const getAllSchool = useQuery([values.useQueryKeys.getAllSchool], () =>
    api.get.common.findSchool({})
  );

  const getAllParentForAdmin = useQuery(
    [values.useQueryKeys.getAllParent, searchedValueParent],
    () =>
      api.post.administrator.getAllParent({
        search: {
          base: searchedValueParent?.base?.value,
          value: searchedValueParent?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" || userType === "PROVINCE_EDUCATION" }
  );
  const getAllParentForCommon = useQuery(
    [values.useQueryKeys.getAllParent, searchedValueParent],
    () =>
      api.post.common.findParent({
        search: {
          base: searchedValueParent?.base?.value,
          value: searchedValueParent?.searchedValue,
        },
      }),
    { enabled: !(userType === "ADMIN" || userType === "PROVINCE_EDUCATION") }
  );
  const getAllParent = getAllParentForAdmin
    ? getAllParentForAdmin
    : getAllParentForCommon;

  const getAllDriverForAdmin = useQuery(
    [values.useQueryKeys.getAllDriver],
    () =>
      api.post.common.findDriver({
        companyId: requestService?.filters?.company?._id,
      }),
    { enabled: userType === "ADMIN" || userType === "PROVINCE_EDUCATION" }
  );
  const getAllDriverForSuperAgent = useQuery(
    [values.useQueryKeys.getAllDriver],
    () => api.post.superAgent.findDriver({}),
    { enabled: !(userType === "ADMIN" || userType === "PROVINCE_EDUCATION") }
  );

  const getAllDriverForCompany = useQuery(
    [values.useQueryKeys.getAllDriver],
    () => api.post.company.findDriver({}),
    { enabled: userType === "COMPANY" }
  );
  const getAllDriver = getAllDriverForAdmin
    ? getAllDriverForAdmin
    : getAllDriverForSuperAgent
    ? getAllDriverForSuperAgent
    : getAllDriverForCompany;

  // api.post.common.findDriver;

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ================================ UseEffect Call ===============================

  // ================================== JSX Content ================================
  let companyInformationWithCompanyName;
  companyInformationWithCompanyName = getAllCompany?.data?.result?.map(
    (item: any) => ({
      ...item,
      companyName: item?.companyInformation?.companyName,
    })
  );
  const AllSuperAgentWithCompleteName = getAllSuperAgent?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );
  const AllParentWithCompleteName = getAllParent?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );
  const AllDriverWithCompleteName = getAllDriver?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );


  return (
    <div className="filter-container">
      <CustomDropdownFilter
        min_width="40vw"
        title={t("filter")}
        hoverTitle={t("filter")}
      >
        <CustomView.Container>
          <CustomView.Row>
            {(userType === "ADMIN" || userType === "COMPANY") && (
              <>
                <CustomView.Column medium={6}>
                  <p className="filter-labels">{t("province")}:</p>
                  <CustomDropdownSearch
                    items={getAllProvince?.data?.result}
                    itemName="Name"
                    isSearch
                    defaultItem={requestService?.filters?.province}
                    onSelectItem={(event: IProvinceItem) =>
                      setRequestService!({
                        ...requestService,
                        filters: {
                          ...requestService?.filters,
                          province: event,
                        },
                      })
                    }
                    placeHolder={t("selectProvince")}
                    isLoading={getAllProvince.isLoading}
                  />
                </CustomView.Column>
                <CustomView.Column medium={6}>
                  <p className="filter-labels">{t("city")}:</p>
                  <CustomDropdownSearch
                    isSearch
                    items={getAllCity?.data?.result}
                    itemName="CityName"
                    defaultItem={requestService?.filters?.city}
                    onSelectItem={(event: ICityItem) =>
                      setRequestService!({
                        ...requestService,
                        filters: {
                          ...requestService?.filters,
                          city: event,
                        },
                      })
                    }
                    placeHolder={t("selectCity")}
                    isLoading={getAllCity.isLoading}
                  />
                </CustomView.Column>
              </>
            )}
            {userType === "ADMIN" && (
              <CustomView.Column medium={6}>
                <p className="filter-labels">{t("superAgent")}:</p>
                <CustomDropdownSearch
                  isSearch
                  items={AllSuperAgentWithCompleteName}
                  itemName="completeName"
                  defaultItem={requestService?.filters?.superAgent}
                  onSelectItem={(event: IProvinceItem) =>
                    setRequestService!({
                      ...requestService,
                      filters: {
                        ...requestService?.filters,
                        superAgent: event,
                      },
                    })
                  }
                  placeHolder={t("selectEducation")}
                  isLoading={getAllSuperAgent.isLoading}
                />
              </CustomView.Column>
            )}
            {userType === "ADMIN" && (
              <CustomView.Column medium={6}>
                <p className="filter-labels">{t("company")}:</p>
                <CustomDropdownSearch
                  isSearch
                  items={companyInformationWithCompanyName}
                  itemName="companyName"
                  defaultItem={requestService?.filters?.company}
                  onSelectItem={(event: ICompanyItem) =>
                    setRequestService!({
                      ...requestService,
                      filters: {
                        ...requestService?.filters,

                        company: event,
                      },
                    })
                  }
                  placeHolder={t("selectCompany")}
                  isLoading={getAllCompany.isLoading}
                />
              </CustomView.Column>
            )}
            <CustomView.Column medium={6}>
              <p className="filter-labels">{t("driver")}:</p>
              <CustomDropdownSearch
                items={AllDriverWithCompleteName}
                itemName="completeName"
                isSearch
                defaultItem={requestService?.filters?.driver}
                onSelectItem={(event: IProvinceItem) =>
                  setRequestService!({
                    ...requestService,
                    filters: {
                      ...requestService?.filters,
                      driver: event,
                    },
                  })
                }
                placeHolder={t("selectDriver")}
                isLoading={getAllDriver.isLoading}
              />
            </CustomView.Column>
            <CustomView.Column medium={6}>
              <p className="filter-labels">{t("parent")}:</p>
              <CustomDropdownMultiSearch
                isSearch
                baseSearch={baseSearch}
                items={AllParentWithCompleteName}
                itemName="completeName"
                onSelectItem={(event: ICompanyItem) => {
                  setSelectedParen(event);
                }}
                defaultItem={selectedParent}
                searchedValue={searchedValueParent}
                setSearchedValue={setSearchedValueParent}
                placeHolder={t("selectParent")}
                isLoading={getAllParent.isLoading}
                selectedBaseSearch={
                  parentPropertyPath.find(
                    (item) => item?.base === searchedValueParent?.base.value
                  )?.value
                }
              />

              {/* <CustomDropdownSearch
                items={AllParentWithCompleteName}
                itemName="completeName"
                isSearch
                defaultItem={requestService?.filters?.parent}
                onSelectItem={(event: IProvinceItem) =>
                  setRequestService!({
                    ...requestService,
                    filters: {
                      ...requestService?.filters,
                      parent: event,
                    },
                  })
                }
                placeHolder={t("selectParent")}
                isLoading={getAllParent.isLoading}
              /> */}
            </CustomView.Column>
            <CustomView.Column medium={6}>
              <p className="filter-labels">{t("school")}:</p>
              <CustomDropdownSearch
                items={getAllSchool?.data?.result}
                itemName="name"
                isSearch
                defaultItem={requestService?.filters?.school}
                onSelectItem={(event: IProvinceItem) =>
                  setRequestService!({
                    ...requestService,
                    filters: {
                      ...requestService?.filters,
                      school: event,
                    },
                  })
                }
                placeHolder={t("selectSchool")}
                isLoading={getAllSchool.isLoading}
              />
            </CustomView.Column>
            <CustomView.Column medium={6}>
              <p className="filter-labels">{t("gender")}:</p>
              <CustomDropdownSearch
                items={gender}
                isSearch
                itemName="name"
                placeHolder={t("selectGender")}
                defaultItem={requestService?.filters?.gender}
                onSelectItem={(event: ICompanyItem) =>
                  setRequestService!({
                    ...requestService,
                    filters: {
                      ...requestService?.filters,
                      gender: event,
                    },
                  })
                }
              />{" "}
            </CustomView.Column>
            <CustomView.Column medium={6}>
              <p className="filter-labels"> {t("grade")}:</p>
              <CustomDropdownSearch
                items={values.dropdownItems.GRADE}
                itemName="name"
                isSearch
                placeHolder={t("selectGrade")}
                defaultItem={requestService?.filters?.grade}
                onSelectItem={(event: ICompanyItem) =>
                  setRequestService!({
                    ...requestService,
                    filters: {
                      ...requestService?.filters,

                      grade: event,
                    },
                  })
                }
              />
            </CustomView.Column>
            <CustomView.Column medium={6}>
              <p className="filter-labels"> {t("field")}:</p>
              <CustomDropdownSearch
                isSearch
                items={values.dropdownItems.FIELD}
                itemName="name"
                placeHolder={t("selectField")}
                defaultItem={requestService?.filters?.field}
                onSelectItem={(event: ICompanyItem) =>
                  setRequestService!({
                    ...requestService,
                    filters: {
                      ...requestService?.filters,

                      field: event,
                    },
                  })
                }
              />
            </CustomView.Column>{" "}
            <CustomView.Column medium={6}>
              <p className="filter-labels"> {t("serviceStatus")}:</p>
              <CustomDropdownSearch
                items={values.dropdownItems.ABSENT_STATUS}
                itemName="name"
                isSearch
                placeHolder={t("selectServiceStatus")}
                defaultItem={requestService?.filters?.absentStatus}
                onSelectItem={(event: IItem) =>
                  setRequestService!({
                    ...requestService,
                    filters: {
                      ...requestService?.filters,
                      statusInService: event.value,
                    },
                  })
                }
              />
            </CustomView.Column>
            <CustomView.Column medium={6}>
              <p className="filter-labels"> {t("factorStatus")}:</p>
              <CustomDropdownSearch
                items={values.dropdownItems.HAS_FACTOR}
                itemName="name"
                isSearch
                placeHolder={t("selectFactorStatus")}
                defaultItem={requestService?.filters?.hasFactor}
                onSelectItem={(event: IItem) =>
                  setRequestService!({
                    ...requestService,
                    filters: {
                      ...requestService?.filters,
                      hasFactor: event,
                    },
                  })
                }
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
        {userType === "ADMIN" && (
          <>
            {/* <p className="filter-labels">وضعیت تاهل:</p> */}
            {/* <DropDownSearchSuperAgent
              defaultValue={selectedFilters?.superAgent?.name}
              onChangeSuperAgent={(selected: iItem | null) => {
                setSelectedFilters({...selectedFilters, superAgent: selected});
              }}
            /> */}
          </>
        )}
        <div className="filter-footer">
          <CustomButton2
            title={t("reset")}
            onClick={() => {
              setRequestService!({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

export default FilterAgent;
